// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewContactLensEyeResponse } from './rapid-review-contact-lens-eye-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewContactLensTrialResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewContactLensTrialResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	contactLensTrialId!: number;

	@GandalfProperty({ designType: RapidReviewContactLensEyeResponse })
	od!: RapidReviewContactLensEyeResponse | null;

	@GandalfProperty({ designType: RapidReviewContactLensEyeResponse })
	os!: RapidReviewContactLensEyeResponse | null;

}
